import {
	faCalculator,
	faChartLineUp,
	faFileInvoiceDollar,
	faFileMagnifyingGlass,
	faTruckContainer,
	faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import { Permission } from '@uturn/portal/abac';
import type { TFunction } from 'i18next';
import type { NavigationItemProps } from '../components/header';

export const getMainNavigation = (
	t: TFunction<'translation', undefined>,
): NavigationItemProps[] => [
	{
		name: t('header.navigation.shipments', 'Shipments'),
		href: '/shipments',
		icon: faTruckContainer,
	},
	{
		name: t('header.navigation.price-calculator', 'Price calculator'),
		href: '/calculator/{-$uuid}',
		icon: faCalculator,
	},
	{
		name: t('header.navigation.invoices', 'Invoices'),
		href: '/invoices',
		icon: faFileInvoiceDollar,
	},
	{
		name: t('header.navigation.my-carriers', 'My Carriers'),
		href: '/carriers',
		icon: faUsers,
	},
	{
		name: t('header.navigation.lanes', 'Lanes'),
		href: '/lanes',
		icon: faUsers,
	},
	{
		name: t('header.navigation.dashboard', 'Data insight'),
		href: '/insights',
		icon: faChartLineUp,
		permission: Permission.METABASE_API,
	},
	{
		name: t('header.navigation.document-reader', 'Document Reader'),
		href: '/document-reader',
		icon: faFileMagnifyingGlass,
	},
];

export const getUserNavigation = (
	orgId: number,
	t: TFunction<'translation', undefined>,
) => [
	{
		name: t('header.navigation.user.account', 'Account'),
		href: '/account',
	},
	{
		name: t('header.navigation.user.organisaton', 'Organisation'),
		href: `/org/${orgId}/settings`,
	},
];
